<template>
  <div>
    <div class="logo">
      <logo></logo>
    </div>
    <div class="registered">
      <div class="registered_info">
        <div class="registered_title">欢迎注册WhaleERP账户</div>
        <div class="registered_content">
          <!--        登录名-->
          <div class="input_info">
            <label>
              <input type="text" class="registered_input" placeholder="设置登录邮箱" v-model="loginName" @focus="focus1" @blur="blur1" autocomplete= "new-password">
            </label>
            <span v-show="show1">请设置登录邮箱</span>
          </div>
          <!--        邀请码-->
          <div class="input_info">
            <label>
              <input type="text" class="registered_input" placeholder="请输入邀请码(没有请忽略)" v-model="invitationCode" autocomplete= "new-password">
            </label>
          </div>
          <!--        第一次输入密码-->
          <div class="input_info">
            <label>
              <input type="password" class="registered_input" placeholder="请输入密码" v-model="password" @focus="focus2" @blur="blur2" autocomplete= "new-password">
            </label>
            <span v-show="show2">
            <p>6-20个字符,密码不能是相同的用户名</p>
            <p>只能包含数字、字母以及标点符号(空格除外)</p>
            <p>数字、字母和标点符号至少包含2种</p>
          </span>
          </div>
          <!--        再次输入密码-->
          <div class="input_info">
            <label>
              <input type="password" class="registered_input" placeholder="请再次输入密码" v-model="againPassword" @focus="focus3" @blur="blur3" autocomplete= "new-password">
            </label>
            <span v-show="show3">请再次输入密码</span>
          </div>
          <!--        验证码-->
          <div style="display: flex">
            <label class="input_item">
              <input type="email" class="registered_input_1" v-model="verity" placeholder="请输入验证码" autocomplete= "new-password">
            </label>
            <img :src="imgSrc" alt="验证码" @click="imgClick" class="verity_img">
          </div>
          <!--        手机号码-->
          <div class="phone_input_module">
            <label>
              <input type="text" placeholder="请输入手机区号" class="phone_name" v-model="phoneName" disabled autocomplete= "new-password">
            </label>
            <label>
              <input type="text" placeholder="请输入手机号码" class="phone_input" v-model="phone">
            </label>
          </div>
          <!--        手机验证码-->
          <div class="input_info my_input">
            <label>
              <input type="text" placeholder="请输入手机验证码" style="height: 20px;margin: 8px 0;width: 200px;font-size: 12px;color: #8b8b8b;padding: 10px;" v-model="phoneVerity" autocomplete= "new-password">
            </label>
            <div class="my_sent_btn" v-if="!time" @click="sendPhone">点击发送</div>
            <div class="my_sent_btn1" v-else>{{ time }} s</div>
          </div>
<!--          <vue-simple-verify ref="verify" width="300" @success="success" movedColor="rgb(252,168,5)"></vue-simple-verify>-->
          <!--        条款-->
          <div class="checkbox_module">
            <label>
              <input type="checkbox" v-model="isAble">
            </label><span @click="navigatorHref(0)">《WhaleERP网站服务条款》</span>|<span @click="navigatorHref(1)">《法律声明和隐私权政策》</span>
          </div>
          <div class="registered_btn_div">
            <button class="registered_btn" :disabled="!isAble" @click="btnClick">注册</button>
          </div>
          <div class="go_login">
            已有账号，<span class="go_login_span" @click="goLogin"> 去登录></span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /*滑动验证*/
  // import VueSimpleVerify from 'vue-simple-verify'
  import {request} from "@/network/request";
  import logo from "@/components/content/logo";

  export default {
    name: "registered",
    components: {
      //滑动组件
      // 'vue-simple-verify': VueSimpleVerify,
      logo
    },
    methods: {
      navigatorHref(i){
        if(i === 0){
          // window.open('/register/static/1.html')
          window.open('/law/WhaleERP用户服务条款.html')
        }
        else if (i === 1){
          // window.open('/register/static/2.html')
          window.open('/law/WhaleERP隐私政策.html')
        }
      },
      success(){
        this.isAble = false
      },
      // 取消弹窗显示
      cancelShow(show){
        this.showPhone = show
      },
      sendPhone(){
        request({
          url: '/register/submitInfo',
          method: 'post',
          header:{
            'Content-Type': 'application/json'
          },
          data: {
            'username': this.loginName,
            'password': this.password,
            'confirmPassword': this.againPassword,
            'phone': this.phoneName + this.phone,
            'verity': this.verity,
            'invitationCode': this.invitationCode
          }
        }).then(res => {
          if(res.data.code === 1){
            request({
              url: '/register/getSms',
              method: 'post',
              header: {
                'Content-Type': 'application/json'
              },
              data: {
                "param": this.phoneName + this.phone
              }
            }).then(res => {
              if(res.data.code === 1){
                if(!this.timer){
                  this.time = 60
                  this.timer = setInterval(() => {
                    if(this.time > 0 && this.time <= 60){
                      this.time --
                    }else {
                      clearInterval(this.timer);
                      this.timer = null
                    }
                  }, 1000)
                }
              }else {
                this.time = 0
                alert(res.data.info)
              }
            })
          }else {
            alert(res.data.info)
            this.imgClick()
          }
        })

      },
      // 注册按钮点击
      btnClick(){
        request({
          url: '/register/register',
          method: 'post',
          header:{
            'Content-Type': 'application/json'
          },
          data: {
            'phone': this.phoneName + this.phone,
            "verity": this.phoneVerity
          }
        }).then(res => {
          if(res.data.code === 1){
            this.$message.success('注册成功')
            this.$router.push('/login')
          }else {
            this.$message.error(res.data.info)
            this.imgClick()
          }
        })
      },
      // 点击切换验证码
      imgClick(){
        this.imgSrc = this.imgSrc + '?' + new Date()
      },
      // 发送最终注册信息
      sendData(){
        request({
          url: '/register/register',
          method: 'post',
          header: {
            'Content-Type': 'application/json'
          },
          data: {
            "phone": this.phoneName + this.phone,
            "verity": this.phoneVerity,
          }
        }).then(res => {
          if(res.data.code === 1){
            this.$router.replace({
              name: 'login'
            })
          }else {
            this.$message.error(res.data.info)
          }
        }).catch(err => {
          console.log(err)
        })
      },
      focus1(){
        this.show1 = true
      },
      blur1(){
        this.show1 = false
      },
      focus2(){
        this.show2 = true
      },
      blur2(){
        this.show2 = false
      },
      focus3(){
        this.show3 = true
      },
      blur3(){
        this.show3 = false
      },
      // 去登录
      goLogin(){
        this.$router.push('login')
      }
    },
    data(){
      return{
        isAble: true,
        // 登录名
        loginName: '',
        // 邀请码
        invitationCode: '',
        // 登录密码
        password: '',
        // 确定密码
        againPassword: '',
        // 手机号码
        phone: '',
        // 验证码
        verity: '',
        // 验证码图片
        imgSrc: '/api/register/getVerity',
        // 是否需要获取手机短信
        showPhone: false,
        // 倒计时
        time: 0,
        timer: null,
        // 手机短信
        phoneVerity: '',
        // 手机区号标识
        phoneName: '+86 ',
        show1: false,
        show2: false,
        show3: false
      }
    }
  }
</script>

<style scoped>
  input{
    outline: none;
    padding: 0 5px;
  }

  input::placeholder{
    color: #a5a5a5;
  }

  input[disabled]{
    background-color: #fff;
  }

  .logo{
    position: relative;
    width: 100%;
    min-width: 1440px;
    background-color: #022028;
    text-align: start;
    padding: 1px 50px;
  }


  .checkbox_module{
    display: flex;
    font-size: 10px;
    margin-top: 15px;
  }

  .my_sent_btn{
    width: 100px;
    line-height: 38px;
    text-align: center;
    background-color: #fff;
    border-left: 1px solid #e6e6e6;
    font-size: 12px;
    color: #8b8b8b;
  }

  .my_sent_btn1{
    width: 100px;
    line-height: 38px;
    background-color: #fff;
    border-left: 1px solid #e6e6e6;
    text-align: center;
    font-size: 12px;
    color: #8b8b8b;
  }

  .my_sent_btn:hover{
    opacity: .8;
    cursor: pointer;
  }

  .checkbox_module span{
    color: #19acfd;
    border-bottom: 1px solid #19acfd;
  }

  .checkbox_module span:hover{
    cursor: pointer;
    border-bottom: none;
  }

  .registered{
    width: 100%;
    min-width: 1440px;
    height: 100%;
    background-color: #f8f8ff;
    padding: 10px 0;
  }

  .registered_info{
    width: 1200px;
    /*height: 600px;*/
    background-color: #fff;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
  }

  .registered_title{
    color: #00dfe3;
    font-size: 20px;
    font-weight: bold;
    padding: 10px 5px;
    text-align: start;
  }

  .registered_content{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }

  .input_info{
    position: relative;
  }

  .my_input{
    height: 40px;
    width: 300px;
    border: 1px solid #e6e6e6;
    margin: 5px 0;
    display: flex;
  }

  .my_input input{
    border: none;
    height: 30px;
  }

  .input_info span{
    position: absolute;
    top: 12px;
    font-size: 12px;
    width: 300px;
    border: 1px solid #e6e6e6;
    border-radius: 2px;
    background-color: #fafafa;
    padding: 10px;
  }

  .input_info span:after{
    content: '';
    position: absolute;
    top: 20px;
    left: -6px;
    width: 10px;
    height: 10px;
    margin-top: -10px;
    background: inherit;
    /*自动继承父元素的背景*/
    transform: rotate(45deg);
    border-left: 1px solid #e6e6e6;
    border-bottom: 1px solid #e6e6e6;
  }

  .input_info span p{
    margin: 5px;
  }

  .registered_btn_div{
    width: 340px;
    text-align: center;
    margin-top: 20px;
  }

  .registered_btn{
    background-color: #00dfe3;
    color: white;
    padding: 10px 20px;
    border: none;
    width: 90%;
  }

  .registered_btn:hover{
    cursor: pointer;
    opacity: .8;
  }

  .registered_btn[disabled]{
    background-color: #cccccc;
  }

  .registered_btn[disabled]:hover{
    cursor: initial;
    opacity: 1;
  }

  .input_module{
    margin: 20px;
    display: flex;
  }

  .phoneInput{
    height: 40px;
    line-height: 40px;
    border: 1px solid #7b7b7b;
    border-right: none;
  }

  .my_btn{
    height: 40px;
    line-height: 40px;
    border: 1px solid #7b7b7b;
    padding: 0 8px;
    width: 100px;
    text-align: center;
  }

  .my_send{
    text-align: center;
  }

  .my_send button{
    padding: 5px 20px;
    outline: none;
  }

  .my_send button:hover{
    opacity: .8;
    cursor: pointer;
  }

  .registered_input{
    height: 40px;
    margin: 5px;
    width: 300px;
    border: 1px solid #e6e6e6;
    font-size: 12px;
    color: #8b8b8b;
    padding: 10px;
  }

  .registered_input_1{
    height: 40px;
    margin: 10px;
    width: 150px;
    border: 1px solid #e6e6e6;
    font-size: 12px;
    color: #8b8b8b;
    padding: 10px;
  }

  .verity_img{
    width: 150px;
    height: 50px;
    margin-bottom: -10px;
  }

  .phone_input_module{
    display: flex;
    border: 1px solid #e6e6e6;
    margin: 5px;
    width: 300px;
  }

  .phone_input_module input{
    height: 20px;
    margin: 10px 0;
    border: none;
  }

  .phone_name{
    width: 40px;
    text-align: center;
    font-size: 12px;
    color: #8b8b8b;
    padding: 10px;
  }

  .phone_input{
    width: 258px;
    font-size: 12px;
    color: #8b8b8b;
    padding: 10px;
  }

  .input_info div{
    float: right;
  }

  .input_box_2{
    width: 170px;
    height: 30px;
    font-size: 16px;
    outline: none;
    margin-right: 20px;
  }

  .input_item{
    /*margin-bottom: 20px;*/
  }

  .go_login{
    padding: 15px;
    width: 100%;
    text-align: start;
    margin: 5px 0 0 0 ;
  }

  .go_login_span{
    color: #19ACFD;
  }

  .go_login_span:hover{
    cursor: pointer;
    opacity: .8;
  }
</style>
